import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const requireContext = require.context('./global', false, /.*\.js$/)

const modules = requireContext.keys().map(file => [file.replace(/(^.\/)|(\.js$)/g, ''), requireContext(file)])

	.reduce((modules, [name, module]) => {
		modules[name] = module
		return modules
	}, {})

export default new Vuex.Store({
	modules
})



// WEBPACK FOOTER //
// ./src/store/index.js